var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2937,
    height: 3719,
    viewBox: "0 0 2937 3719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C03926"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 195.737,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D02D2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 195.737,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D43A30"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 391.474,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA4335"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 391.474,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD322E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 391.474,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D5302E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD2927"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD302B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2C29"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C52321"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D5302E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C42B26"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D12F2C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C13826"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA4335"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D0312B"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D02825"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C92E29"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2F2B"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2C29"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2D29"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2F2B"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD322E"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D4322F"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D0332E"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D22E2D"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB2C29"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE312C"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D63B36"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D0322F"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D32B2B"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2927"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2D26"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D02E2B"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF2B2C"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F18B26"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D53525"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D33430"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2E2B"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF2C2D"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE342C"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF2B29"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D4312A"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E9821B"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E7811C"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D03427"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD2E2A"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D42A2D"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D63934"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC312D"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2828"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF322D"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D3342E"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D4372E"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED8115"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE851A"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE8921"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D73530"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#B63D22"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D4322F"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2927"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2B27"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB2D2A"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD302B"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D1342F"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD322D"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D1342D"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C22D0F"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F08620"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2CF37"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED861F"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D73533"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D13632"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB322C"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D03530"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2927"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB3129"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE332F"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2C21"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C42E13"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D33A32"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D2342B"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB8219"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E8811A"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F3CD3A"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E47815"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE3128"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D0312D"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF3920"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D43532"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D32F2E"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA4335"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC312C"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED861D"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB8520"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB841F"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E77F1C"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC851C"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F1C832"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F8D03D"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E48119"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C72F18"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D53330"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC851C"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D3312F"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D42F2D"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF302C"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA801C"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE8722"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E7821A"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E77D17"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E67F16"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F7D140"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EEC932"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E77E15"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC871F"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB7F1D"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB8217"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D33631"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D22A2A"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2F2A"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF312E"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F1881B"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC871D"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#FAC335"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DC9313"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DA8B12"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5CD38"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC8520"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E8811C"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE8220"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE8623"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F08920"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE302D"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2927"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF342F"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F68036"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB7B19"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2CC3B"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F8CE44"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6D041"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F0C739"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB7B15"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E87E1A"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#FDD64A"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC821C"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F27E2B"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE312A"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 195.738,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2E25"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF2D2B"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED8218"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F4CC37"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F3CA3C"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6CD3F"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F4C93E"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ECC637"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EFC936"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F8CB32"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC831A"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D2332D"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 391.475,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2927"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 587.211,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF2D28"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 782.949,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F08C1D"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2CA37"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#FAD141"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6CD3D"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F4CC37"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EDCB36"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E67C18"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.11,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C32522"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 978.686,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA381F"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F08324"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F3891C"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F37E1F"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire3);
export default __webpack_public_path__ + "static/media/Fire3.96a478b793e2ab07f932b33f118959ae.svg";
export { ForwardRef as ReactComponent };